import type { GetEventsParams } from '@store/models';
import type { EventFilters } from '@/types/planner.types';
import { mapStatusesToEventStates } from '@/utils/plannerEventMapper';

export function hasAnyFilter(filters: EventFilters | undefined | null): boolean {
  if (!filters) return false;
  return (
    filters.owners.length > 0 ||
    filters.statuses.length > 0 ||
    filters.buildings.length > 0 ||
    filters.submissionStartDate != null ||
    filters.submissionEndDate != null ||
    filters.eventStartDate != null ||
    filters.eventEndDate != null
  );
}

// spec 104 FR-018/FR-019/FR-020: serialize the planner-picked day with local-TZ
// accessors so the wire value is the date the planner saw on the picker.
// `toISOString()` would shift by the browser TZ and break per-building filtering.
export function toCalendarDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function eventFiltersToParams(filters: EventFilters): GetEventsParams {
  const params: GetEventsParams = {};
  if (filters.statuses.length > 0) {
    params.status = mapStatusesToEventStates(filters.statuses);
  }
  if (filters.owners.length > 0) {
    params.owner = filters.owners.join(',');
  }
  if (filters.buildings.length > 0) {
    params.buildingId = filters.buildings.join(',') as GetEventsParams['buildingId'];
  }
  if (filters.eventStartDate) {
    params.startDate = toCalendarDate(filters.eventStartDate);
  }
  if (filters.eventEndDate) {
    params.endDate = toCalendarDate(filters.eventEndDate);
  }
  if (filters.submissionStartDate) {
    params.submittedStartDate = toCalendarDate(filters.submissionStartDate);
  }
  if (filters.submissionEndDate) {
    params.submittedEndDate = toCalendarDate(filters.submissionEndDate);
  }
  return params;
}
